<template>
  <resource-form v-if="formIsReady && !showSuccessMessage"
                 @submit="addProspect($event.data)"
                 :model="form.model"
                 :schema="form.schema"
                 :triggers="form.triggers">
  </resource-form>
  <div v-else-if="showSuccessMessage">
    <span>Votre prospect vient d'être ajouté avec succès.</span>
  </div>
</template>

<script>
  import ResourceForm from "components/Forms/ResourceForm"


  export default {
    components: {
      ResourceForm,
    },

    data () {
      return {
        form: {},
        formIsReady: false,
        showSuccessMessage: false
      }
    },

    created () {
      this.axios.get('companies/create')
        .then(response => {
          this.form = _.assign({}, response.data.form)
          this.formIsReady = true
        })
    },

    methods: {
      addProspect (model) {
        this.axios.post('companies', model)
          .then(response => {
            this.showSuccessMessage = true
            const id = response.data.company.company_id
            console.info('prospect created with id:', id)
            this.$router.push({ name: 'customer', params: { id } })
          })
      },
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// client/views/Prospects/CreateProspect.vue